import { CategoryMegaMenuSkeletonProps } from './models';

export const CategoryMegaMenuSkeleton = ({ isDark }: CategoryMegaMenuSkeletonProps) => (
    <div className='flex h-[360px]'>
        <aside className={`w-[280px] shrink-0 border-l p-4 ${isDark ? 'border-neutral-700 bg-[#0b1220]' : 'border-gray-200 bg-[#f9fafb]'}`}>
            <div className={`mb-4 h-10 animate-pulse rounded-lg ${isDark ? 'bg-white/10' : 'bg-N100'}`} />
            <div className='flex flex-col gap-2'>
                {Array.from({ length: 5 }).map((_, index) => (
                    <div key={index} className={`h-12 animate-pulse rounded-lg ${isDark ? 'bg-white/10' : 'bg-N100'}`} />
                ))}
            </div>
        </aside>
        <section className='flex-1 p-6'>
            <div className={`mb-6 h-12 animate-pulse rounded-lg ${isDark ? 'bg-white/10' : 'bg-N100'}`} />
            <div className='grid grid-cols-2 gap-2'>
                {Array.from({ length: 4 }).map((_, index) => (
                    <div key={index} className={`h-14 animate-pulse rounded-lg ${isDark ? 'bg-white/10' : 'bg-N100'}`} />
                ))}
            </div>
        </section>
    </div>
);
